module.exports = __webpack_public_path__ + "0d5fdd6f309145670aac62a2bc1a0a68.ttf";